// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import i18n from './i18n'
import VueWechatTitle from 'vue-wechat-title'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import iviewCNLocale from 'iview/dist/locale/zh-CN'
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VueCookie from '@/assets/js/cookie'
import XAutoComplete from './components/common/xAutoComplete'
import XTabs from './components/common/xtabs'
import XDropdown from './components/common/xdropdown'
import VueHelper from '@/assets/js/helper'
import '@/assets/js/filters'
import VueApi from './api'
import GlobalFuncs from '@/assets/js/funcs'
import App from './App'
import * as vClickOutside from 'v-click-outside-x';

Vue.use(vClickOutside);




/* eslint-disable */

import '@/icons'
import wow from 'wowjs'
import 'wowjs/css/libs/animate.css'
import 'animate.css'
Vue.prototype.$wow = wow
Vue.config.productionTip = false
import AzureStorage from '@/assets/js/azure-storage.blob.min.js'
Vue.prototype.$AzureStorage = AzureStorage

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)
Vue.directive("input-limit", {
  bind(el, binding) {
 
    var wins_0 = /[^\d]/g //\u6574\u6570\u5224\u65ad
    var wins_1 = /[^\d^\.]/g //\u5c0f\u6570\u5224\u65ad
    var flag = true;
    var points = 0;
    var lengths = 0
    var remainder = 0
    var no_int = 0
    const target = el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener("compositionstart", e => {
      flag = false;
    });
    target.addEventListener("compositionend", e => {
      flag = true;
    });
    target.addEventListener("input", e => {
      setTimeout(function() {
        if (flag) {
          if (binding.value == 0) {
            if (wins_0.test(e.target.value)) {
              e.target.value = e.target.value.replace(wins_0, "");
              e.target.dispatchEvent(new Event("input")) //\u624b\u52a8\u66f4\u65b0v-model\u503c
            }
          }
          if (binding.value == 1) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true
            }
            if ((e.target.value.split('.')).length - 1 > 1) {
              points = true
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 1) {
                lengths = true
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false
            } else {
              no_int = true
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace(
                  '$#$', '.').replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                  ".") + 2)
              } else {
                e.target.value = e.target.value.replace(wins_0, "")
              }
              e.target.dispatchEvent(new Event("input"))
            }
          }


          if (binding.value == 2) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true
            }
            if ((e.target.value.split('.')).length - 1 > 1) {
              points = true
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 2) {
                lengths = true
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false
            } else {
              no_int = true
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace(
                  '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                  ".") + 3)
              } else {
                e.target.value = e.target.value.replace(wins_0, "")
              }
              e.target.dispatchEvent(new Event("input"))
            }
          }

          if (binding.value == 3) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true
            }
            if ((e.target.value.split('.')).length - 1 > 1) {
              points = true
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 3) {
                lengths = true
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false
            } else {
              no_int = true
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace(
                  '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                  ".") + 4)
              } else {
                e.target.value = e.target.value.replace(wins_0, "")
              }
              e.target.dispatchEvent(new Event("input"))
            }
          }
          
        }
      }, 0)
    })
  }
})
Vue.use(VueWechatTitle)
Vue.use(VueLodash, {name: 'custom', lodash: lodash})
Vue.use(iView, { locale: iviewCNLocale })
Vue.use(IScrollView, IScroll)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 10100
  }
})
Vue.use(VueCookie)
Vue.use(XAutoComplete)
Vue.use(XTabs)
Vue.use(XDropdown)
Vue.use(VueHelper)
Vue.use(VueApi)
Vue.use(GlobalFuncs)

sync(store, router)
i18n.locale = 'zh-CN'


let _navigator = typeof window.navigator !== 'undefined' ? window.navigator : {}
let userAgent = _navigator.userAgent || ''
let isIE = userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1
let version = '0'
if (isIE) {
  version = parseInt(userAgent.replace(/^.*MSIE ([\d.]+).*$/, '$1').replace(/^.*rv:([\d.]+).*$/, '$1'))
}
Vue._customVars = { isIE: isIE, version: version }

router.beforeEach((to, from, next) => {
  if (to.path === '/' || !to.path || to.name === 'Home') {
    document.querySelector('html').removeAttribute('style')
    document.querySelector('body').classList.remove('novegaspage')
  } else {
    document.querySelector('html').setAttribute('style', 'background:#fff')
    document.querySelector('body').classList.add('novegaspage')
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (Vue._.isEmpty(Vue._h.storage.local.get('uinfo'))) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
      store.commit('account/setModalState', true)
    } else {
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  mounted () {
    this.$nextTick(() => {
      this.$Loading.config({
        color: '#1F8AFD',
        height: 1
      })
      this.$Message.config({
        duration: 4
      })
    })
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js